import { Link } from 'react-router-dom';
import { useSetRecoilState } from 'recoil';
import { Row } from '../../Row';
import { isCartModalOpenState } from '../../../../Header/atoms';
import { OrderStatusEnum } from '../../../graphql';


export type LayoutProps = {
	icon: JSX.Element | string;
	name: JSX.Element | string;
	id: JSX.Element | string;
	price: JSX.Element | string;
	modifiers: JSX.Element | string;
	status?: OrderStatusEnum;
	children?: JSX.Element [] | JSX.Element;
};

export const Layout: React.FC<LayoutProps> = ({
	icon,
	name,
	id,
	price,
	modifiers,
	status,
	children
}) => {
	const setIsCartModalOpen = useSetRecoilState(isCartModalOpenState);
	return (
		<div className="cart-item">
			<Row>
				{status ? (
					<div
						className="ml-0 pr-3"
						style={{ pointerEvents: 'none' }}
					>
						{icon}
					</div>
				) : (
					<Link
						to={`/product/edit/${id}`}
						onClick={() => setIsCartModalOpen(false)}
					>
						<div className="ml-0 pr-3">{icon}</div>
					</Link>
				)}
				<>
					{status ? (
						<p className="text-primary font-weight-bold mb-0">
							{name}
						</p>
					) : (
						<Link
							to={`/product/edit/${id}`}
							onClick={() => setIsCartModalOpen(false)}
						>
							<p className="text-primary font-weight-bold mb-0">
								{name}
							</p>
						</Link>
					)}
					<small className="d-none d-md-block modifiers">
						{modifiers}
					</small>
				</>

				<div className="d-flex ml-3" style={{ gap: '1rem' }}>
					{children}

					<p className="mb-0">${price}</p>
				</div>
			</Row>

			<small className="d-block d-md-none modifiers pt-1">
				{modifiers}
			</small>
		</div>
	);
};
